module.exports = new __parcel__URL__("empty-state-starred.f03d0ca1.svg").toString();